//@flow
import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  RANKING_GET_REQUEST,
  RANKING_USER_GET_REQUEST,
  RANKING_USER_LOAD_REQUEST,
  RANKING_USER_STOP_LOAD,
  GET_CAMPAIGN_TEAM_RANKING_SUCCESS,
  GET_CAMPAIGN_TEAM_RANKING_ERROR,
  GET_CAMPAIGN_TEAM_RANKING_REQUESTING,
  LOAD_CAMPAIGN_TEAM_RANKING_SUCCESS,
  LOAD_CAMPAIGN_TEAM_RANKING_ERROR,
  LOAD_CAMPAIGN_TEAM_RANKING_REQUESTING,
} from "./constants";

import { fetchApi } from "../api";
import { setRanking, setUserRanking, loadUserRanking } from "./actions";

const endPoints = {
  getRanking: "/v1/teams/",
  getCampaignUserRanking: "/v1/campaigns/ranking/user",
  getCampaignTeamRanking: "/v1/teams/campaign/ranking",
};

const getRankingApi = clientId => {
  return fetchApi(endPoints.getRanking + clientId, {}, "get");
};

const getCampaignTeamRanking = data => {
  const { limit, page, campaignId } = data;
  return fetchApi(
    `${endPoints.getCampaignTeamRanking}?campaignId=${campaignId}&page=${page}&limit=${limit}`,
    {},
    "get",
  );
};

const getCampaignUserRankingApi = data => {
  const { limit, page, campaignId } = data;
  return fetchApi(
    `${endPoints.getCampaignUserRanking}?campaignId=${campaignId}&page=${page}&limit=${limit}`,
    {},
    "get",
  );
};

function* getUserRankingFlow(action) {
  try {
    const response = yield call(getCampaignUserRankingApi, action.payload);
    yield put(setUserRanking(response));
  } catch (error) {
    console.log(error);
  }
}

function* loadUserRankingFlow(action) {
  try {
    const response = yield call(getCampaignUserRankingApi, action.payload);
    yield put(loadUserRanking(response));
    if (response.length < 1) {
      yield put({ type: RANKING_USER_STOP_LOAD });
    }
  } catch (error) {
    console.log(error);
  }
}

function* getRankingFlow(action) {
  try {
    const { clientId } = action.payload;
    const response = yield call(getRankingApi, clientId);
    yield put(setRanking(response));
  } catch (error) {
    console.log(error);
  }
}

function* getCampaignTeamRankingFlow(action) {
  try {
    const response = yield call(getCampaignTeamRanking, action.payload);
    yield put({ type: GET_CAMPAIGN_TEAM_RANKING_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: GET_CAMPAIGN_TEAM_RANKING_ERROR, payload: error });
  }
}

function* loadCampaignTeamRankingFlow(action) {
  try {
    const response = yield call(getCampaignTeamRanking, action.payload);
    yield put({ type: LOAD_CAMPAIGN_TEAM_RANKING_SUCCESS, payload: response });
    if (response.length < 1) {
      yield put({ type: RANKING_USER_STOP_LOAD });
    }
  } catch (error) {
    console.log(error);
    yield put({ type: LOAD_CAMPAIGN_TEAM_RANKING_ERROR, payload: error });
  }
}

function* trackWatcher() {
  yield all([
    takeLatest(RANKING_GET_REQUEST, getRankingFlow),
    takeLatest(RANKING_USER_GET_REQUEST, getUserRankingFlow),
    takeLatest(RANKING_USER_LOAD_REQUEST, loadUserRankingFlow),
    takeLatest(
      GET_CAMPAIGN_TEAM_RANKING_REQUESTING,
      getCampaignTeamRankingFlow,
    ),
    takeLatest(
      LOAD_CAMPAIGN_TEAM_RANKING_REQUESTING,
      loadCampaignTeamRankingFlow,
    ),
  ]);
}

export default trackWatcher;
